module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content admin-chat"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "messages"
  }, [_c('ul', _vm._l((_vm.messages), function(msg) {
    return _c('li', [_c('div', {
      staticClass: "media-content"
    }, [_c('div', {}, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.decoded(msg.user)))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(msg.date))]), _vm._v(" "), _c('br'), _vm._v("\n                                                " + _vm._s(msg.text) + "\n                                            ")])])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "controls field has-addons"
  }, [_c('div', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "input is-primary",
    attrs: {
      "placeholder": "Write message",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.sendMessage()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": _vm.message == ''
    },
    on: {
      "click": function($event) {
        _vm.sendMessage()
      }
    }
  }, [_vm._v("Send")])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('h4', {
    staticClass: "title is-4"
  }, [_vm._v("Current users (" + _vm._s(_vm.users.length) + ")")]), _vm._v(" "), _c('ul', _vm._l((_vm.users), function(user) {
    return _c('li', [_c('div', {
      staticClass: "media-content"
    }, [_c('div', {}, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.decoded(user.name)))])])])])])
  }))])])]), _vm._v(" "), _c('br')])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Chat for Admins\n      "), _c('small')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a015beac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/chats/Admin.vue
// module id = 321
// module chunks = 2